import { listAdvertiserBrandProductsService } from '../services/advertiser-brand'

/**
 * O export inclui o nome do produto apenas como informação de apoio. O modelo
 * de importação e o contrato de import usam somente as duas primeiras colunas.
 * A linha por SKU sai com o EAN vazio e o SKU e o publisher no fim.
 */
const HEADERS = ['EAN', 'Marca', 'Nome do produto', 'SKU', 'Publisher']

/** BOM para o Excel abrir os acentos corretamente. */
const BOM = '\uFEFF'

const PAGE_SIZE = 200
/** Mesmo teto de linhas que o import aceita; a tela avisa quando encosta nele. */
export const EXPORT_MAX_ROWS = 5000

/**
 * Célula começando com `= + - @` ou tab/CR vira fórmula ao abrir no Excel;
 * o apóstrofo na frente a mantém como texto.
 */
const neutralizeFormula = (value: string) =>
  /^[=+\-@\t\r]/.test(value) ? `'${value}` : value

const escapeCell = (raw: string) => {
  const value = neutralizeFormula(raw)

  return /[",\n;]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value
}

export const toCsv = (products: AdvertiserBrandProduct[]) =>
  [
    HEADERS.join(','),
    ...products.map(product =>
      [
        product.gtin ?? '',
        product.brand ?? '',
        product.product_name ?? '',
        product.identifier_type === 'sku' ? (product.sku ?? '') : '',
        product.publisher_name ?? ''
      ]
        .map(escapeCell)
        .join(',')
    )
  ].join('\n')

export const downloadAdvertiserProductsCsv = (
  products: AdvertiserBrandProduct[],
  filename: string
) => {
  const blob = new Blob([`${BOM}${toCsv(products)}`], {
    type: 'text/csv;charset=utf-8'
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

/** Percorre a listagem paginada respeitando os filtros da tela. */
export const fetchAllAdvertiserProducts = async (
  params: ListAdvertiserBrandProductsRequest
) => {
  const all: AdvertiserBrandProduct[] = []
  let page = 1

  for (;;) {
    // eslint-disable-next-line no-await-in-loop
    const { data } = await listAdvertiserBrandProductsService({
      ...params,
      page,
      quantity: PAGE_SIZE,
      count: true
    })

    const rows = data?.data ?? []

    all.push(...rows)

    // página vazia encerra mesmo que `total` esteja defasado
    if (
      !rows.length ||
      all.length >= (data?.total ?? 0) ||
      all.length >= EXPORT_MAX_ROWS
    )
      break

    page += 1
  }

  return all.slice(0, EXPORT_MAX_ROWS)
}
